import { Destino } from "./Destino";

export default Destino